export default __webpack_public_path__ + "static/media/payment-info.cf77352c.svg";